import React, { useEffect, useState } from "react";
import styles from "./Components.module.scss";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label, Error } from "@progress/kendo-react-labels";
import { Checkbox } from "@progress/kendo-react-inputs";
import * as api from "api/index";
import { handleApiError } from "Helper";
import { FaExternalLinkAlt } from "react-icons/fa";
import OtpInput from "components/common/OtpInput";

const SecuritySettings = ({ data, onChange, mode, errors = {} }) => {
  const READ_ONLY = mode === "view";
  const [securityProfiles, setSecurityProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [authCode, setAuthCode] = useState("");

  useEffect(() => {
    const fetchSecurityProfiles = async () => {
      try {
        const response = await api.getActiveSecurityProfiles();
        setSecurityProfiles(response?.data?.data || []);
      } catch (error) {
        handleApiError(error);
      }
    };
    fetchSecurityProfiles();
  }, []);

  useEffect(() => {
    if (securityProfiles.length > 0 && data.securityProfileId) {
      const profile = securityProfiles.find(
        (p) => p.profileId === data.securityProfileId
      );
      setSelectedProfile(profile || null);
    }
  }, [securityProfiles, data.securityProfileId]);

  useEffect(() => {
    setAuthCode(data.authCode ?? "");
  }, [data.authCode]);

  const handleFieldChange = (field, value) => {
    onChange(field, value);
  };

  const handleAuthCodeChange = (value) => {
    setAuthCode(value);
    handleFieldChange("authCode", value || null);
  };

  const handleSecurityProfileChange = (e) => {
    setSelectedProfile(e.value);
    handleFieldChange("securityProfileId", e.value?.profileId);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        Security Settings
        <a
          href="#"
          className={styles.changePassword}
          onClick={(e) => e.preventDefault()}
        >
          Change Password <FaExternalLinkAlt className="text-black" />
        </a>
      </div>

      <div className={styles.formGrid}>
        <div className={styles.settingformRow}>
          <div className={styles.formField}>
            <Label>Security Profile</Label>
            <ComboBox
              data={securityProfiles}
              value={selectedProfile}
              textField="profileName"
              onChange={handleSecurityProfileChange}
              placeholder="Select security profile"
              disabled={READ_ONLY}
              className={errors.securityProfileId ? "k-invalid" : ""}
            />
            {errors.securityProfileId && (
              <Error>{errors.securityProfileId}</Error>
            )}
          </div>
        </div>

        <div className={styles.settingformRow}>
          <Label>User Authorization Code</Label>
          <div className={styles.authCodeContainer}>
            <OtpInput
              value={authCode}
              onComplete={handleAuthCodeChange}
              length={4}
            />
          </div>
        </div>

        <div className={styles.settingformRow}>
          <Checkbox
            label="Is App Admin"
            checked={!!data.isAdmin}
            onChange={(e) => handleFieldChange("isAdmin", e.value)}
            disabled={READ_ONLY}
          />
        </div>

        <hr className={styles.horizontalLine} />

        <div className={styles.settingformRow}>
          <h3 className={styles.subtitle}>Product Licenses</h3>
        </div>

        <div className={styles.settingformRow}>
          <Checkbox
            label="Case Management"
            checked={!!data.caseManagement}
            onChange={(e) => handleFieldChange("caseManagement", e.value)}
            disabled={READ_ONLY}
          />
        </div>

        <div className={styles.settingformRow}>
          <Checkbox
            label="Accounts"
            checked={!!data.accounts}
            onChange={(e) => handleFieldChange("accounts", e.value)}
            disabled={READ_ONLY}
          />
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;
